import { useEnvironment } from '@getaccept/lib-shared/src/composables/environment.composable';
import { computed } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import { useUserStore } from '../../user/store/user.store';

export const useMyDocumentsUrl = () => {
  const { user } = storeToRefs(useUserStore());
  const language = computed(() => user.value?.language);

  const { isLocalHost, getUrl } = useEnvironment();

  const getMyDocumentsUrl = (token: string) => {
    if (!token) return null;

    const pathName = `?t=${token}&lang=${language.value}&user=${user.value?.id}`;

    return getUrl({
      prefix: isLocalHost.value ? '' : 'my-documents',
      pathName: isLocalHost.value ? `my-documents${pathName}` : pathName,
    });
  };

  return { getMyDocumentsUrl };
};
